import React, { useCallback, useEffect , useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, Form, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteCityData, getCityList, updateCityStatusData } from "../../redux/actions/CityActions";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import Preloader from "../../Components/Preloader";
import { getAttendanceDailyList, markManagerAttendance } from "../../redux/actions/AttendanceActions";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { CSVLink } from 'react-csv';
import { getDisplayDateTimeFormat,getDateTimeMysqlFormatYm } from "../../util/generalUtills";
import { apiURL } from "../../axios";
import AddAttendnace from "../../Components/FormComponent/AddAttendnace";
import Select from "react-dropdown-select";
import { getMasterUsertypeUserWiseList } from "../../redux/actions/MasterActions";

// Mark Attendance Modal styling
const MarkAttendanceModalDialog = styled(Modal)`
  .modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    overflow: hidden;
  }
  .modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    border: none;
    padding: 1rem 1.25rem;
  }
  .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
  .modal-title {
    font-weight: 600;
    font-size: 1.1rem;
  }
  .modal-body {
    padding: 1.25rem 1.5rem;
  }
`;

const EmployeeInfoCard = styled.div`
  background: linear-gradient(135deg, #f8f9fc 0%, #eef1f8 100%);
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  border-left: 4px solid #667eea;
`;

const StatusLabel = styled.p`
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.75rem !important;
`;

const StatusButtonsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  .btn {
    flex: 1;
    min-width: 100px;
    padding: 0.6rem 1rem;
    font-weight: 600;
    border-radius: 8px;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
    &.btn-success { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); color: #fff; }
    &.btn-warning { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: #fff; }
    &.btn-danger { background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%); color: #fff; }
  }
`;

const DailyAttendance = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageUrl] = useState('');


  const hideAttendanceModel = () => {
    setShowAttendanceModel(false);
    dispatch(getAttendanceDailyList(auth.token, paginate, page, search, sort,month));
  };
  
  const handleImageClick = (imageUrl) => {
    setImageUrl(imageUrl);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setImageUrl("")
  };


  const {
    AuthReducer: { auth,errors,loading },
    attendanceReducers: {
      dailyAttendancePermissions,
      dailyAttendanceLists,
      loadingAttendance,
      errorsAttendance,
      dailyAttendanceCount,
    },
    masterReducer: {
      masterUsertypeLists,
      loadingMaster,
    },
  } = useSelector((city) => city);

  const uploadsBaseUrl = "https://vnassociate.s3.ap-south-1.amazonaws.com";
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(200);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [month, setMonth] = useState(new Date());
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  const [showAttendanceModel, setShowAttendanceModel] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [showManagerAttendanceModal, setShowManagerAttendanceModal] = useState(false);
  const [selectedAttendanceItem, setSelectedAttendanceItem] = useState(null);
  
  const fetchCityList = useCallback(() => {
    if (auth?.token) {
      dispatch(getAttendanceDailyList(auth.token, paginate, page, search, sort,month));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCityList, 500, [auth, paginate, page, search, sort]);

  const filteredAttendanceLists = useMemo(() => {
    if (!selectedUserType || selectedUserType === null) {
      return dailyAttendanceLists;
    }
    return dailyAttendanceLists.filter((item) => {
      return item?.user_types === selectedUserType;
    });
  }, [dailyAttendanceLists, selectedUserType]);

  const csvHead = [['SR No.', 'Name', 'Contact Number', 'User Type',
    'City', 'Working Type', 'Login Time', 'Login Address', 'Logout Time', 'Logout Address']
  ]
  const csvData = filteredAttendanceLists.map((cv, index) => {
    
    return [
      index + 1,
      cv?.name,
      cv?.phone || '',
      cv?.user_types || '',
      cv?.city + "," + cv?.states || '',
      cv?.type || 'Absent',
      cv?.createdAt ? getDisplayDateTimeFormat(cv?.createdAt) : '',
      cv?.login_address || '',
      cv?.logout_time!=null ? getDisplayDateTimeFormat(cv?.logout_time) : '',
      cv?.logout_address || ''
    ];
  });
  const exportData = csvHead.concat(csvData);
  
  useEffect(() => {
    if(errors)
    {
      if(errors?.status==401)
      {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  },[errors])

  const inputDateHandler = (value) => {
    //const { value, name } = e.target;
    //setFormData({ ...formData, [name]: value });
    dispatch({ type: 'GET_ATTENDANCE_RESET' });
    setMonth(value);
    dispatch(getAttendanceDailyList(auth.token, paginate, page, search, sort,value));
  };

  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? dailyAttendanceCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    document.title = `Daily Attendance :: ${auth?.generalSettings?.title}`;
  }, []);

  useEffect(() => {
    if (auth?.token) {
      dispatch(getMasterUsertypeUserWiseList(auth.token));
    }
  }, [auth?.token, dispatch]);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 38,
    }),
  };

  

  const printTable = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(`<html><head><style type="text/css">'+
      '#backgroundImage{'+
        'min-height: 50vh;'+
        'position: relative;'+
        'margin: 0;'+
        '-webkit-print-color-adjust: exact !important; '+
        'color-adjust: exact !important;'+
        '}'+
        '#backgroundImage:before {'+
        'content: "";'+
        'position: absolute;'+
        'z-index: -1;'+
        'top: 0;'+
        'bottom: 0;'+
        'left: 0;'+
        'right: 0;'+
        'opacity: 0.04;'+
        'background:'+
            'url(\'${apiURL}logo.jpg\')'+
        '}'+
        '</style></head><body onload="window.print()" id="backgroundImage"><div align="center ">'+document.title+'</div><div class="main1"><table border="1" cellspacing="0">`);
    printWindow.document.write(document.getElementById('table-to-print').innerHTML);
    printWindow.document.write('</table></div><div align="center">This is a system generated report it does not require any signature or stamp</div><div align="right"><img src="logo.jpg" style="opacity: 0.1"></div></body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };


  const handleManagerAttendance = (item) => {
    setSelectedAttendanceItem(item);
    setShowManagerAttendanceModal(true);
  };

  const handleCloseManagerAttendanceModal = () => {
    setShowManagerAttendanceModal(false);
    setSelectedAttendanceItem(null);
  };

  const handleMarkAttendance = (status) => {
    if (!selectedAttendanceItem?.id) return;
    const payload = { user_id: selectedAttendanceItem.id, status };
    dispatch(markManagerAttendance(auth?.token, payload)).then(() => {
      handleCloseManagerAttendanceModal();
      dispatch(getAttendanceDailyList(auth.token, paginate, page, search, sort, month));
      toast.success(`Marked as ${status}`);
    }).catch(() => {
      toast.error("Failed to update attendance");
    });
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Attendance Report"), path: "/Attendance/Daily", active: false },
          { label: t("Daily Attendance"), path: "/Attendance/Daily", active: true },
        ]}
        title={t("Daily Attendance")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                {(dailyAttendancePermissions.filter ) && (<>
                    <Col lg={3}>
                    <Form.Group className="mb-3">
                      <DatePicker
                        selected={month}
                        onChange={(value) => inputDateHandler(value)}
                        dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                        maxDate={(() => {
                          const date = new Date();
                          //date.setFullYear(date.getFullYear() - 0);  // Subtract 18 years
                          return date;
                        })()}
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                      />
                    </Form.Group>
                  </Col>
                  </>)}
                  {(dailyAttendancePermissions.filter ) && (<>
                    <Col lg={3}>
                      <Form.Group className="mb-3">
                        <Select
                          options={masterUsertypeLists || []}
                          values={masterUsertypeLists?.filter(usertype => usertype.name === selectedUserType) || []}
                          name="userType"
                          labelField={"name"}
                          valueField={"name"}
                          searchBy={"name"}
                          placeholder="Select User Type..."
                          loading={loadingMaster && masterUsertypeLists.length === 0}
                          disabled={loadingMaster && masterUsertypeLists.length === 0}
                          onChange={(selectedData) => {
                            if (selectedData && selectedData.length > 0) {
                              setSelectedUserType(selectedData[0]?.name);
                              setPage(1); // Reset to first page when filter changes
                            } else {
                              setSelectedUserType(null);
                              setPage(1); // Reset to first page when filter is cleared
                            }
                          }}
                          styles={customSelectStyles}
                        />
                      </Form.Group>
                    </Col>
                  </>)}
                  <Col lg={3}>
                    <div className="d-flex align-items-center">
                    {(dailyAttendancePermissions.filter ) && (<>
                      <input
                        type="search"
                        placeholder="Search..."
                        className="form-control ms-1"
                        autoComplete="off"
                        value={search}
                        onChange={handleSearchChange}
                      />
                      
                    </>)}
                      
                    </div>
                  </Col>
                  
                  
                  
                  <Col lg={3}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                      {(dailyAttendancePermissions.add ) && (<>
                        <Button variant="success" onClick={() => {
                          setShowAttendanceModel(true)
                          // setEditHospitalId(null)
                        }} >
                          <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                        </Button>
                      </>)}
                      {(dailyAttendancePermissions.print ) && (<>
                        <Button variant="dark" onClick={printTable}>
                          <i className="mdi mdi-printer me-1"></i>Print
                        </Button>
                      </>)}
                      {(dailyAttendancePermissions.excel ) && (<>
                        <CSVLink
                          filename="daily-attendance-reports.csv"
                          data={exportData}
                          className="btn btn-info text-white ms-1"
                          title="Export To CSV"
                        >
                          <i className="mdi mdi-file-excel me-1"></i>
                          Excel
                        </CSVLink>
                      </>)}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{overflowY:'auto',maxHeight:'500px',border: "1px solid #dee2e6"}}>
                <Table className="mb-0 table-bordered"
                  id="table-to-print"
                  size="sm"
                  striped
                  responsive
                  >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>User Type</th>
                      <th>City</th>
                      <th>Working Type</th>
                      <th>Login Time</th>
                      <th>Logout Time</th>
                      <th>Login Photo</th>
                      <th>Logout Photo</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {filteredAttendanceLists.length === 0 ? (
                    <tr>
                      <td colSpan="12">No data found</td>
                    </tr>
                  ) : (<>
                    {filteredAttendanceLists?.map?.((item, index) => {
                      return (
                        <tr key={item.id || `attendance-${index}-${item.name}`}>
                          <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                          <td>{item?.name}</td>
                          <td>{item?.phone}</td>
                          <td>{item?.user_types}</td>
                          <td>{item?.city}, {item?.states}</td>
                          <td>{
                            item?.type=="Present" ? 
                              <>
                                <Badge className={"bg-success"}>
                                  {item?.type}
                                </Badge>
                              </>
                              : item?.type=="Leave" 
                              ? 
                              <>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-created-at">
                                        {`${item?.leave_remark}`}
                                      </Tooltip>
                                    }
                                  >
                                  <Badge className={"bg-warning"}>
                                  {item?.type}
                                  </Badge>
                                </OverlayTrigger>
                              </>
                              : item?.type=="Week Off"
                              ?
                              <>
                                <Badge className={"bg-purple"}>
                                {item?.type}
                                </Badge>
                              </>
                              : 
                              <>
                                <Badge className={"bg-danger"}>
                                {item?.type}
                                </Badge>
                              </>
                              }</td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-created-at">
                                  {item?.login_address}
                                </Tooltip>
                              }
                            >
                              <span className="d-inline-block" tabIndex="0">
                                {item?.createdAt ? getDisplayDateTimeFormat(item?.createdAt) : ''}
                              </span>
                            </OverlayTrigger>
                          </td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-created-at">
                                  {item?.logout_address}
                                </Tooltip>
                              }
                            >
                              <span className="d-inline-block" tabIndex="0">
                              {item?.logout_time!=null ? getDisplayDateTimeFormat(item?.logout_time) : ''}
                              </span>
                            </OverlayTrigger>
                          </td>
                          <td>
                          {item?.createdAt != null ? (
                            <img 
                              className="avatar-md rounded" 
                              src={`${uploadsBaseUrl}/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.login_image}`} 
                              onClick={() => handleImageClick(`${uploadsBaseUrl}/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.login_image}`)} 
                              alt="Login Image"
                            />
                          ) : ''}
                          </td>
                          <td>
                          {item?.logout_time != null ? (
                            <img 
                              className="avatar-md rounded" 
                              src={`${uploadsBaseUrl}/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.logout_image}`}
                              onClick={() => handleImageClick(`${uploadsBaseUrl}/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.logout_image}`)} 
                              alt="Login Image"
                            />
                          ) : ''}
                          </td>
                          <td >
                            <Button variant="primary" className="btn-sm" onClick={() => handleManagerAttendance(item)}>
                              <i className="mdi mdi-account-multiple"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })}</>
                  )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(filteredAttendanceLists.length / paginate)}</strong> </span>
                <RoundedPagination currentPage={page} totalPages={Math.ceil(filteredAttendanceLists.length / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)}/>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <AddAttendnace show={showAttendanceModel} onHide={() => hideAttendanceModel()} />
      <Modal show={showModal} onHide={handleClose} size="md">
        <Modal.Body>
          <img
            src={imageUrl}
            alt="Full size"
            className="img-fluid"
          />
        </Modal.Body>
      </Modal>

      <MarkAttendanceModalDialog show={showManagerAttendanceModal} onHide={handleCloseManagerAttendanceModal} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="mdi mdi-calendar-check me-2" /> Mark Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAttendanceItem && (
            <EmployeeInfoCard>
              <div className="d-flex align-items-center gap-2">
                <span className="rounded-circle bg-white d-inline-flex align-items-center justify-content-center text-primary" style={{ width: 40, height: 40 }}>
                  <i className="mdi mdi-account" style={{ fontSize: "1.25rem" }} />
                </span>
                <div>
                  <strong className="d-block text-dark">{selectedAttendanceItem?.name}</strong>
                  {selectedAttendanceItem?.phone && (
                    <small className="text-muted">
                      <i className="mdi mdi-phone me-1" />
                      {selectedAttendanceItem.phone}
                    </small>
                  )}
                </div>
              </div>
            </EmployeeInfoCard>
          )}
          <StatusLabel>Select status</StatusLabel>
          <StatusButtonsWrap>
            <Button variant="success" onClick={() => handleMarkAttendance("Present")} disabled={loadingAttendance}>
              <i className="mdi mdi-check-circle" /> Present
            </Button>
            <Button variant="warning" onClick={() => handleMarkAttendance("Half Day")} disabled={loadingAttendance}>
              <i className="mdi mdi-clock-outline" /> Half Day
            </Button>
            <Button variant="danger" onClick={() => handleMarkAttendance("Absent")} disabled={loadingAttendance}>
              <i className="mdi mdi-close-circle" /> Absent
            </Button>
          </StatusButtonsWrap>
        </Modal.Body>
      </MarkAttendanceModalDialog>
      
      {loadingAttendance && (<Preloader/>)}
    </>
  );
};

export default DailyAttendance;
